/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {AnalyticsService} from './@core/utils';
import {CheckForUpdateService} from './@core/utils/check-for-update.service';
import {Title} from '@angular/platform-browser';
import {DOCUMENT} from '@angular/common';
import {ConstantsService} from './@core/utils/constants.service';
import {BehaviorSubject, fromEvent, Observable, Subscription} from 'rxjs';
import {NbToastrService} from '@nebular/theme';

@Component({
	selector: 'ngx-app',
	template: `
		<div >
			<ngx-online-status [onlineStatus]="connStatus"></ngx-online-status>
				<router-outlet></router-outlet>
		</div>
	`,
})
export class AppComponent implements OnInit {
	onlineEvent: Observable<Event>;
	offlineEvent: Observable<Event>;
	subscriptions: Subscription[] = [];
	connStatus = {
		connOnline: false,
		connOffline: false,
		checkStatus: new BehaviorSubject<boolean>(false),
	};

	constructor(private analytics: AnalyticsService, private update: CheckForUpdateService,
                private titleService: Title, private toastr: NbToastrService, @Inject(DOCUMENT) private _document: HTMLDocument,
                public constantsService: ConstantsService) {
        this.setTitle(this.constantsService.title);
        this._document.getElementById('appFavicon').setAttribute('href', this.constantsService.favIcon);
	}

	async ngOnInit() {
		this.analytics.trackPageViews();
		this.checkOnlineStatus();
	}

	public setTitle(newTitle: string) {
		this.titleService.setTitle(newTitle);
	}
	checkOnlineStatus() {
		this.onlineEvent = fromEvent(window, 'online');
		this.offlineEvent = fromEvent(window, 'offline');

		this.subscriptions.push(this.onlineEvent.subscribe(() => {
			// this.toastr.success('Internet is back online.', 'Connected!', {duration: 0});
			this.connStatus.connOnline = true;
			this.connStatus.connOffline = false;
			this.connStatus.checkStatus.next(true);
		}));

		this.subscriptions.push(this.offlineEvent.subscribe(() => {
			// this.toastr.warning('Internet is offline.', 'Check Connectivity!', {duration: 0});
			this.connStatus.connOffline = true;
		}));
	}



}
